"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    @media screen and ${constants_1.Device.mobileL} {
        font-size: 14px;
    }
    .overlay-wrapper {
        max-width: 800px;
        position: relative;
        display: flex;
        flex-direction: column;
        @media only screen and (max-height: 600px) {
            height: 100%;
        }
        @media screen and ${constants_1.Device.mobileL} {
            padding-top: 2.5%;
        }
        .overlay-close {
            position: absolute;
            right: 0.5em;
            top: 0;
            font-size: 2em;
            text-transform: lowercase;
            cursor: pointer;
            transform: scale(1);
            transition: color 300ms ease-in-out, transform 300ms ease-in-out;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 1000;
            -webkit-font-smoothing: antialiased;
            &:before {
                content: 'x';
            }
            &:hover {
                transform: scale(1.15);
            }
            @media screen and ${constants_1.Device.mobileL} {
                top: 3%;
                right: 3%;
            }
        }
        .overlay-content-wrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            @media screen and ${constants_1.Device.mobileL} {
                flex-wrap: wrap;
            }
        }
        .overlay-content {
            text-align: center;
            background: linear-gradient(to right, #0e0e0e 0%, #3d3d3d 100%);
            padding: 5% 2%;
            .overlay-content-block {
                width: 50%;
                padding: 1em;
                display: inline-block;
                text-align: left;
                vertical-align: top;
                @media screen and ${constants_1.Device.mobileL} {
                    width: 100%;
                    text-align: center;
                }
            }

            h1 {
                line-height: 1;
            }

            img {
                width: 100%;
                display: block;
            }

            .buttons-container {
                button + button {
                    margin: 0 1em;
                    @media screen and ${constants_1.Device.mobileL} {
                        margin: 0.5em 0;
                    }
                }
            }
        }
    }
`;
//# sourceMappingURL=OverlayStyled.js.map